export default __webpack_public_path__ + "static/media/image_folders.16ec65a1.svg";